import { supabase } from '../lib/supabase';

// Get user profile
export const getUserProfile = async (userId) => {
  try {
    const { data, error } = await supabase
      .from('user_profiles')
      .select('*')
      .eq('id', userId)
      .single();

    if (error) {
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw error;
  }
};

// Update user profile
export const updateUserProfile = async (userId, profileData) => {
  try {
    console.log('Updating profile for user:', userId);
    console.log('Profile data:', profileData);
    
    const { data, error } = await supabase
      .from('user_profiles')
      .update(profileData)
      .eq('id', userId)
      .select()
      .single();

    if (error) {
      console.error('Supabase error details:', error);
      throw error;
    }

    console.log('Profile updated successfully:', data);
    return data;
  } catch (error) {
    console.error('Error updating user profile:', error);
    console.error('Error code:', error.code);
    console.error('Error message:', error.message);
    console.error('Error details:', error.details);
    throw error;
  }
};

// Get user orders
export const getUserOrders = async (userId) => {
  try {
    const { data, error } = await supabase
      .from('user_orders')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false });

    if (error) {
      throw error;
    }

    return data || [];
  } catch (error) {
    console.error('Error fetching user orders:', error);
    throw error;
  }
};

// Get user order by ID
export const getUserOrderById = async (userId, orderId) => {
  try {
    const { data, error } = await supabase
      .from('user_orders')
      .select('*')
      .eq('user_id', userId)
      .eq('id', orderId)
      .single();

    if (error) {
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Error fetching user order:', error);
    throw error;
  }
};

// Create new order
export const createUserOrder = async (orderData) => {
  try {
    const { data, error } = await supabase
      .from('user_orders')
      .insert([orderData])
      .select()
      .single();

    if (error) {
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Error creating user order:', error);
    throw error;
  }
};

// Update order status
export const updateOrderStatus = async (orderId, status) => {
  try {
    const { data, error } = await supabase
      .from('user_orders')
      .update({ status })
      .eq('id', orderId)
      .select()
      .single();

    if (error) {
      throw error;
    }

    return data;
  } catch (error) {
    console.error('Error updating order status:', error);
    throw error;
  }
};

export default {
  getUserProfile,
  updateUserProfile,
  getUserOrders,
  getUserOrderById,
  createUserOrder,
  updateOrderStatus
}; 